import { useTheme } from "@fluentui/react";
import * as React from "react";
/**
 * HOC that injects the current theme into the component props
 * @param Component Component to wrap
 */ export function withTheme(Component) {
    return function WrappedComponent(props) {
        const theme = useTheme();
        return /*#__PURE__*/ React.createElement(Component, {
            ...props,
            theme: theme
        });
    };
}
